import { useEffect, useRef, useState } from "react";
import { CheckCircle2, FileText, X } from "lucide-react";
import "./product-note-button.css";

export function ProductNoteButton({ note, productName, acknowledgementRequired, acknowledgedBy, saving, onAcknowledge, sourceLabel }: {
  note: string;
  sourceLabel?: string;
  productName: string;
  acknowledgementRequired: boolean;
  acknowledgedBy: string | null;
  saving: boolean;
  onAcknowledge: () => void;
}) {
  const [open, setOpen] = useState(false);
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (!open) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialog.current?.showModal();
    return () => { dialog.current?.close(); document.body.style.overflow = previous; };
  }, [open]);
  return <div className="product-note-access">
    <button type="button" aria-haspopup="dialog" onClick={() => setOpen(true)}><FileText size={19} />Ürün notu{acknowledgementRequired ? <small>Okumanız gerekiyor</small> : null}</button>
    <dialog ref={dialog} className="product-note-dialog" aria-label="Ürün notu" onCancel={() => setOpen(false)} onClose={() => setOpen(false)}>
      <header><h2>Ürün notu</h2><button type="button" aria-label="Ürün notunu kapat" onClick={() => setOpen(false)}><X size={22} /></button></header>
      <h3>{productName}</h3>{sourceLabel ? <small>{sourceLabel}</small> : null}<p className="product-note-content">{note}</p>
      {acknowledgementRequired ? <button type="button" disabled={saving} onClick={onAcknowledge}><CheckCircle2 size={18} />{saving ? "Kaydediliyor…" : "Okudum"}</button> : acknowledgedBy ? <small className="operator-note-acknowledged"><CheckCircle2 size={16} />Okundu · {acknowledgedBy}</small> : null}
    </dialog>
  </div>;
}
